<template>
  <div class="download-computer-root">
    <div class="background-wrapper">
      <img class="sp3" src="/assets/images/bg-lbf.png" alt="" />
      <img class="sp6" src="/assets/images/bg-rbf.png" alt="" />
      <img class="sp1" src="/assets/images/bg-lt.png" alt="" />
      <img class="sp2" src="/assets/images/bg-lb.png" alt="" />
      <img class="sp4" src="/assets/images/bg-rt.png" alt="" />
      <img class="sp5" src="/assets/images/bg-rb.png" alt="" />
      <img class="sp7" src="/assets/images/qp.png" alt="" />
    </div>
    <div class="container" v-show="!hasError">
      <div
        class="mid"
        v-loading="isLoading"
        element-loading-background="rgba(0,0,0,0)"
      >
        <img class="zylkcss" src="/assets/images/zylk.png" />
      </div>
      <div
        v-if="bgImg"
        class="background"
        :style="{ 'background-image': `url(${bgImg})` }"
      ></div>
      <div class="app-info mid" v-show="!isLoading">
        <div class="code">
          <canvas class="qrcode" width="180" ref="qrcodeRef"></canvas>
          <img class="logo" width="40" :src="logoUrl" />
        </div>
        <div class="app-name">{{ appName + appLog }}</div>
        <div class="app-version">
          <img src="/assets/images/footericon.png" alt="" />
          <span>{{ versionMsg }}</span>
        </div>
        <div class="download-button" @click="handleDownload">
          <i
            :class="['platform', 'iconfont', 'icon-' + iconEnum[platform]]"
          ></i>
          &nbsp;{{ textEnum[platform] }}
        </div>
        <div class="mobile-switch">
          <span>当前为PC环境，</span
          ><span class="link-like" @click="handleSwitchToMobile"
            >点击前往移动端</span
          >
        </div>
      </div>
    </div>
    <div class="container error-tip" v-show="hasError">
      <div class="mid">
        <div>出错了： {{ errorMessage }}</div>
        <br />
        <div class="home-button" @click="handleLogin">点击登录</div>
      </div>
    </div>

    <el-dialog
      v-model="dialogVisible"
      title="请输入密码"
      width="300px"
      top="35vh"
      :close-on-click-modal="false"
    >
      <el-input v-model="password" v-tc-auto-focus="dialogVisible" />
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="handleConfirm">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 下载进度条 -->
    <div v-if="showProgress" class="download-progress-overlay">
      <div class="progress-container">
        <div class="progress-text">{{ loadDonwText }}</div>
        <div class="progress-bar-wrapper">
          <div class="progress-bar" :style="{ width: downloadProgress + '%' }">
            <span class="progress-percentage">{{ downloadProgress }}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  getCurrentInstance,
  onMounted,
  ref,
  watch,
  defineProps,
  defineEmits,
} from "vue";
import {
  apiGetAppInfoByUri,
  apiGetApplePackageUrlForComputer,
  apiGetPackageUrl,
  apiGetUserInfoWithRedirt,
} from "@/Api/AppApi";
import { humanSize } from "@/Utils/UtilTools";
import QRCode from "qrcode";

const props = defineProps(["uri"]);
const emit = defineEmits(["switch-to-mobile"]);

const { appContext } = getCurrentInstance();
const $moment = appContext.config.globalProperties.$moment;
const $message = appContext.config.globalProperties.$message;

const errorMessage = ref("");
const hasError = ref(false);
let uri = "";
watch(
  () => props.uri,
  (val) => {
    if (!val) {
      errorMessage.value = "缺少app短链";
      hasError.value = true;
      return;
    }
    hasError.value = false;

    uri = val;
    getAppInfo();
  },
  { immediate: true }
);
onMounted(() => {
  if (props.uri) {
    hasError.value = false;
    uri = props.uri;
    getAppInfo();
  } else {
    hasError.value = true;
    errorMessage.value = "缺少app短链";
  }
});

const iconEnum = ["apple", "android", "windows", "app-store", "linux"];
const textEnum = [
  "iPhone",
  "Android",
  "Windows安装包",
  "MacOS安装包",
  "Linux安装包",
];

const isLoading = ref(false);
const appName = ref("");
const logoUrl = ref("");
const versionMsg = ref("");
const platform = ref(0);
const qrcodeRef = ref(null);
const bgImg = ref("");
const appLog = ref("");
let app = null;
async function getAppInfo() {
  isLoading.value = true;
  const res = await apiGetAppInfoByUri(uri);
  isLoading.value = false;
  bgImg.value = "";
  if (res.code === 0) {
    app = res.data;
    bgImg.value = app.background_img;
    initDataShow();
  } else {
    hasError.value = true;
    if (res.code === 28) {
      errorMessage.value = "没有找到对应的app";
    } else {
      errorMessage.value = res.message;
    }
  }
}
const packData = ref({})
function initDataShow() {
  const release = app.releaseversion || {};
  const pack = release.package || {};
  packData.value = pack;
  appName.value = pack.appname || app.appname;
  appLog.value = release.releasenote
  logoUrl.value = release.package.logo || app.logourl;
  platform.value = app.platform - 1;

  versionMsg.value = `${pack.version || ""} (Build ${
    pack.buildnumber
  }) - ${humanSize(pack.size, 1)} 更新时间: ${$moment(
    release.createtime
  ).format("YYYY/MM/DD HH:mm")}`;

  QRCode.toCanvas(
    qrcodeRef.value,
    location.href,
    {
      maskPattern: 4,
      width: 180,
      margin: 2,
      errorCorrectionLevel: "H",
    },
    (err) => {
      if (err) {
        console.log(err);
        hasError.value = true;
        errorMessage.value = "二维码生成失败";
      }
    }
  );
}

const password = ref("");
const dialogVisible = ref(false);
const downloadProgress = ref(0);
const showProgress = ref(false);
const loadDonwText = ref("正在下载准备中...");
function handleDownload() {
  if (app.password === "true") {
    dialogVisible.value = true;
  } else {
    doDownload();
  }
}
function handleConfirm() {
  if (password.value.length > 0) {
    dialogVisible.value = false;
    doDownload();
  } else {
    $message({ type: "warning", message: "密码为空，请输入密码。" });
  }
}

async function getPackageUrl() {
  const release = app.releaseversion;
  const versionId = release.id;
  let res;
  if (app.platform === 1) {
    const data = {
      password: password.value,
      activityid: "",
    };
    res = await apiGetApplePackageUrlForComputer(app.id, versionId, data);
  } else {
    const data = {
      id: versionId,
      password: password.value,
      activityid: "",
    };
    res = await apiGetPackageUrl(data);
  }

  if (res.code === 0) {
    return res.data;
  } else if (res.code === 30000) {
    $message({
      type: "error",
      message: "密码错误，请重新输入密码。",
    });
  } else {
    $message({
      type: "error",
      message: res.message,
    });
  }
}

let downloading = false;
async function doDownload() {
  if (downloading) {
    return;
  }

  downloading = true;
  const url = await getPackageUrl();
  downloading = false;
  if (url) {
    // 检查包名是否包含"剑世4主干-轻量包"
    const needBlobDownload = appName.value && (app.id == "676a1494cf1b5a1fb8d076ee" || app.id == "66260df3cf1b5ae46c6695f3");

    if (needBlobDownload) {
      // 使用 blob 方式下载，显示进度条
      try {
        showProgress.value = true;
        downloadProgress.value = 0;

        const response = await fetch(url);
        const contentLength = response.headers.get('content-length');
        const total = parseInt(contentLength, 10);

        const reader = response.body.getReader();
        const chunks = [];
        let receivedLength = 0;

        while (true) {
          const { done, value } = await reader.read();

          if (done) break;

          chunks.push(value);
          receivedLength += value.length;

          if (total) {
            downloadProgress.value = Math.round((receivedLength / total) * 100);
          }
        }

        // 合并所有chunks
        const blob = new Blob(chunks);

        // 创建 Blob URL
        const blobUrl = URL.createObjectURL(blob);

        // 创建下载链接
        const node = document.createElement("a");
        node.href = blobUrl;
        node.download = appName.value + appLog.value + `_v${packData.value.version}.${packData.value.buildnumber}` + '.apk';

        // 必须将元素添加到 DOM 才能确保 click 生效
        document.body.appendChild(node);

        node.click();
        loadDonwText.value = "数据准备中..."

        setTimeout(() => {
          node.remove();
          URL.revokeObjectURL(blobUrl);
          showProgress.value = false;
          downloadProgress.value = 0;
        }, 5000);
      } catch (error) {
        console.error('下载失败:', error);
        showProgress.value = false;
        downloadProgress.value = 0;
        $message({
          type: 'error',
          message: '下载失败，请重试'
        });
      }
    } else {
      // 使用原来的直接下载方式
      const node = document.createElement("a");
      node.href = url;
      node.click();
      node.remove();
    }
  }
}

function handleLogin() {
  apiGetUserInfoWithRedirt();
}

function handleSwitchToMobile() {
  emit("switch-to-mobile");
}
</script>

<style lang="scss" scoped>
.download-computer-root {
  width: 100%;
  height: 100%;
  position: relative;
}

.background-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;

  .sp3 {
    position: absolute;
    bottom: 170px;
  }

  .sp6 {
    position: absolute;
    bottom: 160px;
    right: 38px;
  }

  .sp1 {
    position: absolute;
    top: 0px;
  }

  .sp2 {
    position: absolute;
    bottom: 0px;
  }

  .sp4 {
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .sp5 {
    position: absolute;
    bottom: 0px;
    right: -50px;
  }

  .sp7 {
    position: absolute;
  }
}

.container {
  width: 100%;
  height: 100%;

  .mid {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
  }

  .background {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    overflow: hidden;
    opacity: 0.5;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .zylkcss {
    min-width: 576px;
    max-width: 724px;
    max-height: 797px;
    height: auto;
    width: 34%;
    margin-top: -23px;
  }

  .code {
    position: relative;

    .logo {
      position: absolute;
      top: 70px;
      left: 70px;
      border-radius: 4px;
    }
  }

  .app-name {
    font-size: 20px;
    color: #fff;
    margin: 18px 0;
  }

  .app-version {
    font-size: 12px;
    color: #fff;

    img {
      vertical-align: bottom;
    }
    span {
      margin-left: 4px;
    }
  }

  .download-button {
    border: 1px solid #fff;
    width: 200px;
    height: 48px;
    color: #fff;
    font-size: 21px;
    margin: 42px 0;
    cursor: pointer;
    text-align: center;
    line-height: 48px;
    vertical-align: middle;
    border-radius: 4px;
    user-select: none;
  }

  .mobile-switch {
    font-size: 12px;
    color: #f2dede;

    .link-like {
      border-bottom: 1px solid;
      cursor: pointer;

      &:hover {
        color: #fff;
      }
    }
  }
}

.error-tip {
  color: #fff;
  font-size: 16px;

  .home-button {
    color: #fff;
    cursor: pointer;
    border: 1px solid #fff;
    width: 200px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 4px;
    user-select: none;
  }
}

.download-progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  .progress-container {
    background: #fff;
    padding: 30px 40px;
    border-radius: 8px;
    min-width: 400px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

    .progress-text {
      font-size: 16px;
      color: #333;
      margin-bottom: 16px;
      text-align: center;
    }

    .progress-bar-wrapper {
      width: 100%;
      height: 24px;
      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 12px;
      overflow: hidden;
      position: relative;

      .progress-bar {
        height: 100%;
        background-color: #409eff;
        transition: width 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .progress-percentage {
          font-size: 12px;
          color: #fff;
          font-weight: bold;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
